import { useEffect, useRef } from 'react';

import {
  GOOGLE_PAY_BASE_PAYMENT_DATA_REQUEST,
  GOOGLE_PAY_BUTTON_PROPS,
  GOOGLE_PAY_ENABLED,
  GOOGLE_PAY_ENVIRONMENT,
  GOOGLE_PAY_SCRIPT_URL,
  GOOGLE_PAY_SUPPORTED_PAYMENT_CONFIG
} from '@/config/tapPayments';
import { createTapTokenForGooglePay } from '@/services/payment.service';

const GooglePay = ({
  onClickPayAmount,
  setLoading,
  setShowToast,
  setTapSanitizedToken,
  transactionAmount
}) => {
  const paymentsClientRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!GOOGLE_PAY_ENABLED) return;

    if (!window.google?.payments) {
      const script = document.createElement('script');
      script.src = GOOGLE_PAY_SCRIPT_URL;
      script.async = true;
      script.onload = initGooglePay;
      document.head.appendChild(script);
    } else {
      initGooglePay();
    }
  }, []);

  const initGooglePay = () => {
    paymentsClientRef.current = new window.google.payments.api.PaymentsClient({
      environment: GOOGLE_PAY_ENVIRONMENT
    });

    paymentsClientRef.current
      .isReadyToPay(GOOGLE_PAY_SUPPORTED_PAYMENT_CONFIG)
      .then(({ result }) => {
        if (result) {
          addGooglePayButton();
        } else {
          console.error('Google Pay is not available.');
        }
      })
      .catch((err) => {
        console.error('isReadyToPay error:', err);
      });
  };

  const addGooglePayButton = () => {
    const button = paymentsClientRef.current.createButton({
      onClick: onGooglePayClick,
      ...GOOGLE_PAY_BUTTON_PROPS
    });
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(button);
    }
  };

  const onGooglePayClick = () => {
    const paymentDataRequest = {
      ...GOOGLE_PAY_BASE_PAYMENT_DATA_REQUEST,
      transactionInfo: {
        ...GOOGLE_PAY_BASE_PAYMENT_DATA_REQUEST.transactionInfo,
        totalPrice: transactionAmount
      }
    };

    paymentsClientRef.current
      .loadPaymentData(paymentDataRequest)
      .then(async (paymentData) => {
        const googlePayTokenStr =
          paymentData.paymentMethodData.tokenizationData.token;
        let googlePayToken;
        try {
          googlePayToken = JSON.parse(googlePayTokenStr);

          await createTapTokenForGooglePay({
            googlePayToken,
            setLoading,
            setShowToast,
            setTapSanitizedToken
          });
          await onClickPayAmount();
        } catch {
          console.error('Failed to parse Google Pay token JSON');
          setLoading(false);
          setShowToast({
            show: true,
            status: false,
            message: 'Failed to process Google Pay token. Please try again.'
          });
        }
      })
      .catch((err) => {
        console.error('loadPaymentData failed', err);
      });
  };

  return <div ref={containerRef} />;
};

export default GooglePay;
